<template>
  <div class="gis-container">
    <div class="lamp-search">
      <div :class="searchShow?'search-text search-show':'search-text'">
        <el-select
          class="search-select"
          v-model="selectedLamp"
          :placeholder="$t('gis.please_name')"
          filterable
          clearable
          @change="selectChange"
        >
          <el-option
            v-for="lamp in markers"
            :key="lamp.lamp_id"
            :label="lamp.name"
            :value="{value:lamp.lamp_id, longitude:lamp.longitude, latitude:lamp.latitude}"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-btn" @click="searchShow=!searchShow"><i class="el-icon-search"></i></div>
    </div>
    <el-amap
      ref="gmap"
      vid="gmapDemo"
      :center="center"
      :zoom="zoom"
      class="gmap-box"
      :mapStyle="'amap://styles/light'"
    >
      <template v-for="(marker, index) in markers">
        <el-amap-marker
          v-if="marker && !isNaN(marker.longitude) && !isNaN(marker.latitude) && marker.longitude !== null && marker.latitude !== null"
          :key="index"
          :position="[Number(marker.longitude), Number(marker.latitude)]"
          :icon="markerIcon(marker.ste)"
          :offset="[-25, -72]"
          :events="{ click: () => markerClick(marker) }"
          :vid="index"
          :title="marker.name"
        >
        </el-amap-marker>
      </template>
      <el-amap-info-window
        :position="currentWindow.position"
        :visible="currentWindow.visible"
        :events="{ close: () => close() }"
        closeWhenClickMap="true"
      >
        <div>
          <h3 class="info-title" :title="lampInfo.name">{{ lampInfo.name }}</h3>
          <div class="info-content">
            <div v-html="getGasValue(lampInfo.sb)"></div>
          </div>
          <div class="info-controls">
            <div class="botton-one" @click="backLightList(lampInfo.lamp_id)">
              <div class="icon">
                <svg-icon name="lamp-control"/>
              </div>
              <div class="text">{{$t("control.lamp_control")}}</div>
            </div>
            <div v-if="lampInfo.camera_list&&lampInfo.camera_list.length" class="botton-one" @click="videoPreview(lampInfo.camera_list[0])">
              <div class="icon">
                <svg-icon name="video-preview"/>
              </div>
              <div class="text">{{$t("control.camera")}}</div>
            </div>
          </div>
        </div>
      </el-amap-info-window>
    </el-amap>
    <!-- 查看监控 -->
    <div
      class="box_control_bg"
      v-if="videoData.dialogVisible"
      @click="closeVideo"
    ></div>
    <div class="box_control" v-if="videoData.dialogVisible">
      <div class="box_head">
        <span class="box_title">{{$t("gis.view_camera")}}</span>
        <div class="box_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <div class="video-left">
          <video-box
            ref="video_home_box"
            :video="videoData"
          ></video-box>
        </div>
        <div class="video-right">
          <video-control
            ref="video_home_control"
            :video="videoData"
          ></video-control>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import lampsApi from "@/api/device/lamps";
import videoControl from "@/components/video/VideoControl";
import videoBox from '@/components/video/VideoBox.vue'
import store from '@/store'
export default {
  name: "Amap",
  components: {
    videoBox,
    videoControl
  },
  data() {
    return {
      selectedLamp: "",
      searchShow: 0,
      zoom: 18,
      center: store.state.user.account_map.center,
      markers: [],
      currentWindow: {
        position: store.state.user.account_map.center,
        visible: false,
      },
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      pageInfo: {
        sortBy: 'lamp_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 500
      },
      videoData: {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      }
    };
  },
  created() {
    // console.log('store.state.user', store.state.user)
    this.getLampList();
  },
  methods: {
    getLampList() {
      lampsApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          if(this.$store.state.user.role_type==1){
            this.zoom=8
          }else{
            this.zoom=18
          }
          this.markers = resData.list;
        }
      });
    },
    selectChange(params) {
      const { value, longitude, latitude } = params
      if (value) {
        //根据Id获取设备信息
        lampsApi.lightInfo(value).then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data;
            resData.longitude = longitude
            resData.latitude = latitude
            this.markerClick(resData);
          }
        });
      }
    },
    markerIcon(ste) {
      let icon = ''
      let theme = this.$theme
      if(theme=='moonLightWhite'){
        if(ste){
          icon = require("../../assets/images/light_online.png")
        }else{
          icon = require("../../assets/images/light_line.png")
        }
      }else{
        if(ste){
          icon = require("../../assets/images/darkblue_online.png")
        }else{
          icon = require("../../assets/images/darkblue_line.png")
        }
      }
      return icon
    },

    markerClick(marker) {
      this.center = [Number(marker.longitude), Number(marker.latitude)];
      this.zoom = 18;
      this.lampInfo = marker;
      this.currentWindow.position = [Number(marker.longitude), Number(marker.latitude)];
      this.currentWindow.visible = true;
    },
    close() {
      this.currentWindow.visible = false;
      this.videoData.dialogVisible = false;
    },
    videoPreview(video) {
      if (!this.video.number) {
        return
      }
      cameraApi.cameraInfo({
        number: video.number,
        channel: video.channel
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoData = {
            id: res.data.data.id,
            title: res.data.data.title,
            number: res.data.data.number,
            camera_type: res.data.data.camera_type,
            channel: res.data.data.channel,
            access_token: res.data.data.access_token,
            dialogVisible: true
          }
        }
      });
    },
    closeVideo() {
      this.videoData = {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      }
    },
    videoGetAccessToken() {
      lampsApi.getAccessToken().then((res) => {
        this.accessToken = res.data.accessToken;
      });
    },
    getGasValue(items) {
      let gas_data = this.$t("system.gas_data");
      let itemValue = "";
      for (let i in items) {
        if (items[i].sb_tye == 8) {
          itemValue +=
            items[i].name + "：" + gas_data[items[i].value] + "<br/>";
        } else {
          itemValue += items[i].name + "：" + items[i].value + "<br/>";
        }
      }
      return itemValue;
    },
    backLightList(){
      this.$router.push({ path: '/device/lamps' })
    }
  }
};
</script>

<style lang='less'>
@color-primary:#336b96;
.gis-container {
  width:100%;
  height:100%;
  position: relative;
  .lamp-search {
    position: absolute;
    top: 38px;
    right: 50px;
    z-index: 999;
    width:350px;
    .search-text{
      width:300px;
      overflow: hidden;
      padding:10px;
      box-sizing: border-box;
      .search-select{
        opacity: 0;
        height:50px;
        transform: translateX(100%);
        transition: all 0.5s;
        display: block;
        .el-input__inner {
          min-width:100px;
          height:50px;
          border-radius: 50px;
          font-size: 16px;
          padding-left: 20px;
          border: none;
          box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
          &::placeholder,&::-webkit-input-placeholder {
            color: #333;
          }
          &:hover,&:focus {
            border-color: transparent;
          }
        }

        .el-icon-caret-top {
          display: none !important;
        }
      }
      &.search-show{
        .search-select{
          opacity: 1;
          transform: translateX(0);
          transition: all 0.5s;
        }
      }
    }
    .search-btn{
      position: absolute;
      right:0;
      top:10px;
      z-index: 22;
      background-color: @color-primary;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      width:50px;
      height:50px;
      font-size: 28px;
      border-radius: 50%;
      cursor: pointer;
      box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
    }
  }

  
  .gmap-box {
    height: 100%;
    width: 100%;
    position: relative;
    min-height: 700px;
  }
  h3.info-title {
    margin: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color:#111 !important;
  }
  .info-content {
    padding:0 10px 10px;
    overflow: hidden;
    color:#333 !important;
  }
  .info-content span {
    width: 150px;
    float: left;
  }
  .info-controls {
    padding:5px 10px 10px;
    display: flex;
    align-items: center;
    .botton-one{
      margin-right: 20px;
      cursor: pointer;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .icon{
        border: 1px solid rgba(51, 153, 204, 0.5);
        border-radius: 50%;
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        background-color: #e9e9ed;
        color:#222;
      }
      .text{
        padding: 5px 0;
        font-size: 14px;
        text-align: center;
        color:#222;
      }
      &:hover{
        .icon{
          color:#000;
          background-color: #e9e9ed;
        }
        .text{
          color:#000;
        }
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
}
.video-left{
  width:600px;
  height:400px;
  float: left;
}
.video-right{
  float: right;
}
</style>
